export default __webpack_public_path__ + "static/media/Voxel_Architects_C01.89725ff9.mp4";